import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { useState } from "react";
import toast from "react-hot-toast";
import WithdrawalMangementServices from "../../../services/WithdrawalMangementServices";

const money = (v) => Number(v || 0).toFixed(2);

/**
 * Approve / reject confirmation.
 * Approve shows the payout figure and destination account prominently - the
 * admin has to transfer that money by hand, so it must never be a blind click.
 */
const WithdrawalActionModal = ({ row, mode, onClose, onDone }) => {
  const withdrawalApi = new WithdrawalMangementServices();
  const isApprove = mode === "approve";

  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!isApprove && !remark.trim()) {
      toast.error("Please give a reason for rejecting");
      return;
    }
    setLoading(true);
    try {
      const response = await withdrawalApi.updateStatus(
        row.id,
        isApprove ? "APPROVE" : "REJECT",
        remark.trim() || undefined,
      );
      if (response.isSuccess) {
        toast.success(response.message);
        onDone();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          `Failed to ${isApprove ? "approve" : "reject"} withdrawal`,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show onHide={onClose} backdrop="static" centered className="custom-modal">
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">
          {isApprove ? "Approve Withdrawal" : "Reject Withdrawal"}
        </h5>
        <button type="button" className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      <Modal.Body>
        <div className="wd-summary">
          <div className="wd-summary-row">
            <span>Player</span>
            <strong>
              {row.user_name} ({row.game_id})
            </strong>
          </div>
          <div className="wd-summary-row">
            <span>Requested amount</span>
            <strong>₹{money(row.amount)}</strong>
          </div>
          {Number(row.fee_amount) > 0 && (
            <div className="wd-summary-row">
              <span>
                Fee ({Number(row.fee_percentage)}%)
                <small className="wd-fee-note"> stays locked in player wallet</small>
              </span>
              <strong className="wd-fee">−₹{money(row.fee_amount)}</strong>
            </div>
          )}
          <div className="wd-summary-row wd-summary-total">
            <span>{isApprove ? "Transfer to player" : "Payout would be"}</span>
            <strong>₹{money(row.payout_amount)}</strong>
          </div>
        </div>

        {isApprove && (
          <div className="wd-bank-box">
            <div className="wd-bank-label">Send to</div>
            <div className="wd-bank-name">{row.bank_name}</div>
            <div className="wd-bank-line">
              <span>Account holder</span>
              <strong>{row.account_holder_name}</strong>
            </div>
            <div className="wd-bank-line">
              <span>Account number</span>
              <strong className="wd-acc-strong">{row.account_number}</strong>
            </div>
            <div className="wd-bank-line">
              <span>IFSC</span>
              <strong className="wd-acc-strong">{row.ifsc_code}</strong>
            </div>
            {!!row.upi_id && (
              <div className="wd-bank-line">
                <span>UPI ID</span>
                <strong>{row.upi_id}</strong>
              </div>
            )}
          </div>
        )}

        {isApprove ? (
          <p className="wd-warn">
            ₹{money(row.payout_amount)} will be debited from the player and
            credited to <strong>{row.parent_name || "your wallet"}</strong> —
            the same figure you must transfer to the account above.
            {Number(row.fee_amount) > 0 && (
              <>
                {" "}
                The ₹{money(row.fee_amount)} fee is not credited to anyone: it
                stays in the player's wallet as locked play credit they can bet
                with but never withdraw.
              </>
            )}{" "}
            Approve only once you are ready to pay.
          </p>
        ) : (
          <p className="wd-warn wd-warn-danger">
            No wallet change. The player keeps their balance and will see your
            reason.
          </p>
        )}

        <label className="form-label mt-2">
          {isApprove ? "Remark (optional)" : "Reason for rejection"}
          {!isApprove && <span className="text-danger"> *</span>}
        </label>
        <textarea
          className="form-control"
          rows={2}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
          placeholder={
            isApprove
              ? "e.g. paid via NEFT, ref 123456"
              : "e.g. bank details do not match the player's name"
          }
          maxLength={500}
        />
      </Modal.Body>

      <div className="modal-footer border-0">
        <button
          type="button"
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="button"
          className={`btn px-4 ${isApprove ? "btn-success" : "btn-danger"}`}
          onClick={submit}
          disabled={loading}
        >
          {loading
            ? isApprove
              ? "Approving..."
              : "Rejecting..."
            : isApprove
              ? "Approve & Pay"
              : "Reject"}
        </button>
      </div>
    </Modal>
  );
};

export default WithdrawalActionModal;
